/* 
The idea is to always pubish and listen to the most parent frame. 
Since we've no cross domain issues this should be pretty straight forward 
*/

const frames = ['editor', 'previewer', 'text-app'];

export const types = [
  'TEXT_CLICKED',
  'TEXT_CLICKED_OUTSIDE',
  'PREVIEWER_RESIZED',
  'DISPATCH_TO_STORE',
  'TEXT_APP_SCROLL',
  'TEXT_RESIZE',
].reduce((prev, curr) => {
  prev[curr] = 'CONVERDY/' + curr;
  return prev;
}, {});
// Todo add logger?
export function sendMessage(options) {
  const {event, data} = options;

  // Validation
  // validateInput(options);

  // Get editorWindow
  const editorWindow = getParentIframe();

  editorWindow.postMessage(options);
}

export function onMessage(callback = () => {}) {
  // Get editor window
  const editorWindow = getParentIframe();

  function handler(e) {
    callback(e.data, e);
  }

  editorWindow.addEventListener('message', handler);

  // Remove listner function
  return function () {
    editorWindow.removeEventListener('message', handler);
  };
}

// Get most outer parent iframe (in our case this should be the editor)
function getParentIframe() {
  return window.top;
}

function validateInput({event, data}) {
  if (!event || !data) {
    throw new Error('Please define, frame, event and date!');
  }

  if (!frames.includes(frame)) {
    throw new Error(
      'Frame should be one of: ' +
        frames.join(', ') +
        ' given frame was ' +
        frame,
    );
  }
}

export default {
  onMessage,
  postMessage,
  types,
};
